import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Gift, Mail, Image as ImageIcon, Video } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SubscribeGate = () => {
  const [msg, setMsg] = useState(null);
  const [promo, setPromo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const on = (e) => {
      setMsg(typeof e.detail === "string" ? e.detail : "اشترك للاستفادة من خدمات رواج الذكية");
      if (!promo) api.get("/coupons/promo").then((r) => setPromo(r.data)).catch(() => {});
    };
    window.addEventListener("rawaj:subscribe", on);
    return () => window.removeEventListener("rawaj:subscribe", on);
  }, [promo]);

  if (!msg) return null;
  const go = () => { setMsg(null); navigate("/app/packages"); };
  return (
    <Dialog open onOpenChange={(o) => !o && setMsg(null)}>
      <DialogContent className="bg-popover border-border max-w-md" dir="rtl" data-testid="subscribe-gate-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="w-5 h-5 text-accent" /> اشترك للاستفادة من خدمات رواج الذكية</DialogTitle>
          <DialogDescription data-testid="subscribe-gate-message">{msg}</DialogDescription>
        </DialogHeader>
        <div className="rounded-2xl border border-accent/40 bg-accent/5 p-4 space-y-2">
          <div className="flex items-center gap-2 font-bold"><Gift className="w-5 h-5 text-accent" /> تجربة مجانية لمدة شهر</div>
          <div className="flex gap-4 text-sm">
            <span className="flex items-center gap-1"><ImageIcon className="w-4 h-4 text-primary" /> صورتان</span>
            <span className="flex items-center gap-1"><Video className="w-4 h-4 text-primary" /> فيديو واحد</span>
            <span className="text-muted-foreground">مشروع «محتوى متنوع»</span>
          </div>
          {promo?.code && (
            <div className="text-sm">الكوبون: <b className="text-accent tracking-widest" dir="ltr" data-testid="subscribe-gate-code">{promo.code}</b></div>
          )}
        </div>
        <Button onClick={go} className="w-full font-bold gap-2" data-testid="subscribe-gate-cta">
          <Gift className="w-4 h-4" /> فعّل التجربة المجانية
        </Button>
        <p className="text-xs text-muted-foreground text-center flex items-center justify-center gap-1">
          <Mail className="w-3.5 h-3.5" /> اقتراحاتك وتوصياتك:
          <a href="mailto:Support@Rawajsmart.com" className="text-primary hover:underline" dir="ltr" data-testid="subscribe-gate-email">Support@Rawajsmart.com</a>
        </p>
      </DialogContent>
    </Dialog>
  );
};
